module.exports = new function quickspinMap() {

    window.initMap = function() {
        var mapStyle =
        [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];

        var SthlmlatLng = {lat: 59.3374835, lng: 18.0368471};
        var MaltalatLng = {lat: 35.9139436, lng: 14.4933964};
        var UkrainelatLng = {lat: 50.438969198009666, lng: 30.52308795767113};
    
        var SthlmMapOptions = {
            zoom: 15,
            minZoom: 5,
            scrollwheel: false,
            disableDefaultUI: false,
            mapTypeControl: false,
            center: SthlmlatLng,
            styles: mapStyle
        };

        var MaltaMapOptions = {
            zoom: 15,
            minZoom: 5,
            scrollwheel: false,
            disableDefaultUI: false,
            mapTypeControl: false,
            center: MaltalatLng,
            styles: mapStyle
        };

        var UkraineMapOptions = {
            zoom: 15,
            minZoom: 5,
            scrollwheel: false,
            disableDefaultUI: false,
            mapTypeControl: false,
            center: UkrainelatLng,
            styles: mapStyle
        };

        if ( document.querySelector('.quickspin-maps') != null ) {
            var map = new google.maps.Map(document.getElementById('sthlm-map'), SthlmMapOptions);
            var marker = new google.maps.Marker({
                position: SthlmlatLng,
                map: map,
                title: 'Quickspin AB'
            });

            var map = new google.maps.Map(document.getElementById('malta-map'), MaltaMapOptions);
            var marker = new google.maps.Marker({
                position: MaltalatLng,
                map: map,
                title: 'Quickspin AB'
            });

            var map = new google.maps.Map(document.getElementById('ukraine-map'), UkraineMapOptions);
            var marker = new google.maps.Marker({
                position: UkrainelatLng,
                map: map,
                title: 'Quickspin AB'
            });

            google.maps.event.addDomListener(window, "resize", function() {
               var center = map.getCenter();
               google.maps.event.trigger(map, "resize");
               map.setCenter(center);
            });
        }
    };


};
